export default __webpack_public_path__ + "static/prog6-886e4fc94b29f611caf5c0dec3a9acca.mp4";